import React from 'react';
import classes from '../index.module.scss';

const PurchasesTableHeader = () => {
  return (
    <tr>
      <th className={`${classes.No_Wrap}`}>
        Title
      </th>
      <th>
        Options
      </th>
    </tr>
  )
}

export default PurchasesTableHeader;